export const bookingDetailsConfig = {
  DEFAULT: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    ticketLabel: "View Tickets",
    showCancelButton: true,
  },

  NOC: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Receipt",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  IP1: {
    carparkLabel: "Carpark Name",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
  },

  BFS: {
    carparkLabel: "Carpark Name",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  PV1: {
    carparkLabel: "Parking Lot",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
  },

  SV1: {
    carparkLabel: "Parking Lot",
    showVrn: false, // explicitly no VRN
    resendEmail: false,
    receiptLabel: "View Ticket",
    vrnLabel: "Existing VRN",
    ticketLabel: "View Ticket",
    showCancelButton: false,
  },

  ML1: {
    carparkLabel: "Parking Lot",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  PB1: {
    carparkLabel: "Car Park",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  YHM: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Receipt",
    vrnLabel: "Licence Plate",
    showCancelButton: true,
  },

  DRW: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Receipt",
    vrnLabel: "Licence Plate",
    showCancelButton: true,
  },

  HER: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Receipt",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  LAS: {
    carparkLabel: "Airport Name",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  FMM: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  RSW: {
    carparkLabel: "Airport Name",
    showVrn: false, // explicitly no VRN
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: false,
  },
  AB1: {
    carparkLabel: "Airport Name",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: false,
  },

  NWI: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  NQY: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
  },

  JER: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  LDY: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  AIR: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: false,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  BHX: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },


  LAX: {
    carparkLabel: "Airport Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing VRN",
  },

  OKC: {
    carparkLabel: "Airport Name",
    showVrn: false,
    resendEmail: false,
    receiptLabel: "View Receipt",
    vrnLabel: "Existing VRN",
  },

  SB2: {
    carparkLabel: "Station Name",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Receipt",
    vrnLabel: "Existing VRN",
    showCancelButton: true,
  },

  ST1: {
    carparkLabel: "Parking Lot",
    showVrn: true,
    resendEmail: true,
    receiptLabel: "View Invoice",
    vrnLabel: "Existing LPN",
    showCancelButton: true,
  },

  // Add more brands as needed...
};